const messages = {
    scanWithBankApp: "Pindai menggunakan aplikasi perbankan Anda",
    scanWithCreditCardApp: "Pindai menggunakan aplikasi kartu kredit Anda",
    scanOrOpenApp: "Pindai atau buka aplikasi untuk menyelesaikan pembayaran",
    scanForPayment: "Pindai untuk melakukan pembayaran",
    scanWithBankApp: 'Pindai dengan aplikasi perbankan Anda untuk membayar',
    changePaymentWarning: "Setelah Anda mengubah metode pembayaran, QR Code sebelumnya tidak berlaku lagi. Gunakan metode baru saja.",
    swapShop: "Apakah Anda ingin beralih ke<br>toko baru?",
    swapShopDespt: "Item yang dipilih dari toko sebelumnya akan disimpan dan dapat dipesan nanti",
    sorryForInconvenient: 'Kami mohon maaf atas ketidaknyamanan ini',
    openAt: 'Buka pukul',
    shopIsClosedToday: 'Toko Tutup Hari Ini',
    checkOrderedItem: 'Periksa makanan yang dipesan',
    tryAgainIn: 'Coba lagi pada',
    lockUserPIN: "Anda telah memasukkan PIN salah lebih dari 5 kali",
    lockUserPINDespt: "Coba lagi dalam 5 menit",
    inValidPIN: 'PIN salah',
    enterPasswordToAccessMenu: "Masukkan PIN untuk mengakses menu",
    customersCanGetPasswordFromStaff: "Pelanggan dapat meminta PIN dari staf",
    tableNotAvailable: "Meja tidak tersedia",
    contactStaffToOpenTable: "Hubungi staf untuk membuka meja",
    outOfRestaurantRange: "Di luar jangkauan restoran",
    phoneIsMoreThan100MetersAwayFromRestaurant: "Ponsel Anda lebih dari 100 meter dari restoran",
    restaurantIsCurrentlyClosed: "Restoran saat ini tutup",
    restaurantOpenHours: "Dapur buka dari",
    packingSize: 'Ukuran Paket',
    shippingDelivery: 'Pengiriman',
    waitForPaymentDelivery: 'Menunggu Pembayaran',
    readyForPcikup: 'Siap Diambil',
    noNotifyNow: "Tidak ada notifikasi saat ini",
    noNotifyNowDespt: "Setelah Anda mulai menggunakan layanan, notifikasi Anda akan muncul di sini",
    newAddressDespt: "Untuk pengiriman yang lebih mudah, silakan pin lokasi yang benar dan izinkan akses ke lokasi Anda",
    deleteAddressSuccess: 'Alamat Berhasil Dihapus',
    createProfileSuccess: "Profil Berhasil Dibuat",
    ex: 'Contoh',
    receiverName: 'Nama Penerima',
    editAddress: 'Edit Alamat',
    nameInputInvalid: 'Nama Salah',
    openInGoogleMap: 'Buka Google Map',
    pleaseSelectPaymentMethod: 'Silakan Pilih Metode Pembayaran',
    noDeliveryAddress: 'Alamat pengiriman tidak ditemukan',
    noDeliveryAddressDespt: 'Silakan tambahkan informasi alamat pengiriman',
    deliveryType: 'Pengiriman',
    pickupType: 'Ambil Sendiri',
    shopIsClose: 'Toko Tutup',
    openingHoursDespt: 'Jam Buka',
    contactShop: 'Hubungi Toko',
    pickupAtShop: 'Ambil Sendiri',
    thanksForOrderingDespt: 'Terima kasih atas kebaikan Anda.<br>Kami berharap dapat bertemu Anda lagi!',
    deliveredSuccess: 'Terkirim',
    expireIn: 'Kedaluwarsa Dalam',
    waitForPayment: 'Menunggu Pembayaran',
    waitForPaymentDespt: "Silakan tunggu konfirmasi pembayaran dari sistem.<br>Jika Anda belum melakukan pembayaran, silakan selesaikan pembayaran dalam waktu yang ditentukan untuk menghindari pembatalan pesanan.",
    newOrderIn: 'Baru',
    inputRequestDetails: 'Tentukan detail permintaan',
    notification: 'Notifikasi',
    noticeIfOrderReady: 'Kami akan memberi tahu Anda ketika pesanan siap diambil',
    orderIsReady: 'Pesanan Anda siap untuk diambil',
    thanksForOrdering: 'Terima kasih telah menggunakan layanan kami',
    toPay: 'Bayar',
    letOrder: 'Buka halaman menu dan mulai pesan sekarang',
    noTransaction: 'Tidak Ada Transaksi',
    menulists: 'Daftar Menu',
    editPersonalDetails: 'Edit Detail',
    trackOrder: 'Lacak Pesanan',
    myAccount: 'Akun Saya',
    cart: 'Keranjang',
    helpCenter: 'Pusat Bantuan',
    allPurchaseHistory: 'Riwayat Pembelian',
    purchaseHistory: 'Riwayat Pembelian',
    personalInfo: 'Detail Pribadi',
    cutlery: 'Peralatan Makan',
    km: 'km',
    totalAmountSum: 'Total',
    selectedItemList: 'Item Terpilih',
    iAm: 'Saya',
    orderedBy: 'Dipesan oleh',
    shareQRtoFriend: 'Bagikan QR Code',
    share: 'Bagikan',
    hasItemInBasket: 'Ada item di keranjang',
    hasItemInBasketDespt: 'Jangan lupa kirim ke dapur',
    updatedAtQR: 'Diperbarui pada',
    orderSent: 'Pesanan dikirim ke dapur',
    orderSentDespt: 'Restoran sedang menyiapkan makanan Anda',
    checkGramdTotalIn: 'Anda dapat memeriksa total di',
    vatNotInclude: 'Harga ini belum termasuk pajak, biaya layanan, dan diskon',
    accept: 'Terima',
    termOfService: 'Ketentuan Layanan',
    onPending: 'Tertunda',
    OnSuccessOrder: 'Berhasil',
    prepareingOrder: 'Menyiapkan Pesanan',
    deliveringOrder: 'Mengantar Pesanan',
    pickupOrderReady: 'Siap Diambil',
    pickedupOrder: 'Pesanan Telah Diambil',
    deliveredOrder: 'Pesanan Terkirim',
    shopReceivedOrder: 'Toko Menerima Pesanan',
    orderId: 'ID Pesanan',
    orderDetails: 'Detail Pesanan',
    deliveryFee: 'Biaya Pengiriman',
    searchDriver: 'Mencari pengemudi',
    driverFrom: 'Pengemudi dari',
    change: 'Ubah',
    deliveryAddress: 'Alamat Pengiriman',
    location: 'Lokasi',
    addressName: 'Nama Alamat',
    addressNameDespt: 'contoh, Nama Apartemen, Nama Perumahan',
    addressDescription: 'Detail Alamat',
    addressDescriptionDespt: 'contoh, Nomor Gedung, Gang',
    noteToDriver: 'Catatan untuk Pengemudi',
    noteToDriverDespt: 'Contoh: Letakkan di meja pintu masuk',
    inputAddressForm: 'Masukkan Alamat Pengiriman',
    plsPinAddress: 'Pin lokasi Anda',
    pinLocation: 'Pin Lokasi Pengiriman',
    createNewAddress: 'Buat Alamat Baru',
    savedAddress: 'Alamat Tersimpan',
    phoneNumber: 'Nomor Telepon',
    noRequired: 'Opsional',
    resendCode: 'Kirim ulang kode',
    didNotGetCode: 'Tidak menerima kode?',
    resendIn: 'Kirim ulang dalam',
    next: 'Berikutnya',
    createAccount: 'Buat Akun',
    createAccountDespt: 'Isi formulir di bawah untuk membuat akun',
    sendCodeViaSMS: 'Kirim kode via SMS',
    inputOTP: 'Masukkan OTP',
    inputOTPDespt: 'Silakan masukkan kode 6 digit yang dikirim ke',
    termAndPolicy: 'Syarat dan Kebijakan',
    termAndPolicy1: 'Dengan menggunakan layanan kami, Anda menyetujui',
    termAndPolicy2: 'Klik untuk membaca Syarat dan Kebijakan selengkapnya',

    loginWithPhoneNumber: 'Masuk dengan Nomor Telepon',
    loginWithPhoneNumberDespt: 'Masukkan nomor telepon untuk menerima OTP verifikasi identitas',
    backToOrder: 'Kembali ke Menu',
    PaymentMethod: 'Pembayaran',
    paymentAmount: 'Jumlah pembayaran',
    paymentConfirmation: 'Konfirmasi Pembayaran',
    cancelPayment: 'Batalkan Pembayaran',
    paidSuccess: 'Pembayaran Selesai',
    haveNotPurchased: 'Belum melakukan pembelian',
    haveNotPurchased2: 'Jika Pembayaran Gagal, Silakan Hubungi Staf',
    canNotOrderItem: 'Anda tidak dapat memesan makanan saat melakukan pembayaran',
    checkPaymentStatus: 'Cek Status',
    pendingPayment: 'Pembayaran Tertunda',
    askForReceipt: 'Jika Anda memerlukan kwitansi, silakan hubungi staf',
    paymentSuccess: 'Pembayaran Berhasil',
    summaryPayment: 'Ringkasan',
    numberOfGuest: 'Jumlah Tamu',
    closeTab: 'Tutup',
    addCredit: 'Tambah Kartu Kredit',
    QRPayment: 'Pembayaran QR',
    cardPayment: 'Kartu Kredit',
    payWithStaff: 'Bayar di Kasir',
    selectPaymentMethod: 'Pilih Metode Pembayaran',
    checkOut: 'Bayar',
    startOrderBeforeCallStaff: 'Silakan pesan makanan sebelum memanggil staf',
    basket: 'Keranjang',
    spoon: 'Minta peralatan makan',
    knife: 'Minta pisau',
    chopstick: 'Minta sumpit',
    cup: 'Minta cangkir',
    plate: 'Minta piring',
    glass: 'Minta gelas',
    payBill: 'Minta tagihan',
    viewAll: 'Lihat Semua',
    recommendMenu: 'Rekomendasi',
    OnSuccess: 'Berhasil',
    OnPreparing: 'Menyiapkan',
    messageSent: 'Silakan tunggu staf kami',
    outOfStock: 'Habis',
    QRCode: 'QR Code',
    GenerateQRCode: 'Buat QR Code',
    ForQROrder: 'Untuk memesan makanan dan meminta layanan di toko',
    QROrderDescription: 'Anda dapat membuat QR Code untuk pelanggan memindai untuk memesan makanan dan meminta layanan di toko',
    SelectTable: 'Pilih meja dan masukkan jumlah tamu.',
    shopname: 'Nama Toko',
    numberOfCustomer: 'Jumlah pelanggan (orang)',
    numberOfCustomerDescription: 'Masukkan jumlah pelanggan, minimal 1 orang',
    currentUser: 'Pengguna',
    guest: 'Tamu',
    orderItem: 'Ringkasan Pesanan',
    orderItemNav: 'Ringkasan Pesanan',
    callStaff: 'Panggil Staf',
    callStaffDialog: 'Bantuan apa yang Anda butuhkan?',
    cutlery: 'Minta peralatan makan',
    seasoning: 'Minta bumbu',
    refillDrink: 'Minta isi ulang minuman',
    other: 'Lainnya',
    tableNumber: 'Meja',
    menuList: 'Menu',
    selectedItem: 'Pesan Makanan',
    selectedItemNav: 'Pesan Makanan',
    checkOrderBeforeConfirm: 'Silakan verifikasi detail pesanan dan total sebelum mengirim ke restoran',
    checkOrderBeforeConfirm2: '',
    startOrder: 'Mulai Pesan',
    foodCategory: 'Kategori',
    searchByName: 'Cari Produk Berdasarkan Nama...',
    noPreduct: 'Tidak ada produk tersedia',
    noSelectedProduct: 'Tidak ada item terpilih',
    noSelectedProductDespt: 'Jika Anda telah memilih produk, daftar pilihan Anda akan ditampilkan di halaman ini',
    backToMenu: 'Ke Menu',
    removeSelected: 'Apakah Anda ingin menghapus item ini?',
    confirmOrder: 'Kirim Pesanan',
    endOfTransection: 'Akhir transaksi',
    endOfTransectionDialog: 'Jika ada masalah penggunaan, silakan hubungi staf',
    note: 'Catatan',
    orderTime: 'Waktu pesan',
    orderMoreFood: 'Kembali ke Menu Utama',
    orderPreparing: 'Koki kami sedang menyiapkan makanan Anda. Silakan tunggu sebentar. Makanan Anda akan segera disajikan',
    orderPreparing2: '',
    sendingOrder: 'Mengirim Pesanan ke Dapur...',
    login: 'Masuk',
    forgetPassword: 'Lupa Kata Sandi',
    loginWithGmail: 'Masuk dengan Gmail',
    or: 'atau',
    loginAsStaff: 'Masuk Sebagai Staf',
    billOrder: 'Tagihan',
    table: 'Meja',
    billOrderDialog: 'Pindai QR Code untuk melihat menu dan memesan',
    billOrderDialog2: 'Jika ada masalah penggunaan, silakan hubungi staf',
    selectTableAleart: 'Silakan pilih meja sebelum membuat QR Code',
    emptyCartDialog: 'Tidak Ada Transaksi',
    emptyCartDialogDespt: 'Jika Anda mengkonfirmasi pesanan, daftar item yang dipesan akan ditampilkan di halaman ini',
    served: 'Disajikan',
    contactOurStaff: 'Hubungi Staf Kami',
    contactOurStaff2: 'Untuk meminta bantuan',
    addToCart: 'Tambah ke Keranjang',
    noteToShop: 'Catatan untuk toko',
    addYourRequest: 'Tambahkan permintaan Anda',
    branchName: 'Nama Cabang',
    businessType: 'Jenis Usaha',
    taxID: 'NPWP',
    vat: 'Pajak',
    exclusive: 'Belum termasuk pajak',
    inclusive: 'Sudah termasuk pajak',
    serviceCharge: 'Biaya Layanan',
    address: 'Alamat',
    address1: 'Alamat Baris 1',
    address2: 'Alamat Baris 2',
    tel: 'Telepon',
    businessType1: 'Umum',
    businessType2: 'Restoran',
    businessType3: 'Hostel',
    shopopen: 'Buka - Tutup',
    open: 'Buka',
    closed: 'Tutup',
    languagetxt: 'Bahasa',
    language: 'Bahasa & Zona Waktu',
    languageTH: 'Thai',
    languageEN: 'Inggris',
    setting: 'Pengaturan',
    shop: 'Toko',
    timezone: 'Zona Waktu',
    deliveryProviders: 'Penyedia Pengiriman',
    adddeliveryProviders: 'Tambah Penyedia',
    lastUpdate: 'Terakhir diperbarui',
    logo: 'Logo',
    updateData: 'Perbarui data',
    submit: 'Kirim',
    cancel: 'Batal',
    normal: 'Normal',
    loading: 'Memuat...',
    editing: 'Mengedit',
    confirmUpdate: 'Apakah Anda ingin memperbarui data?',
    selectedShoptype: 'Pilih Jenis Usaha...',
    selectshop: 'Pilih Nama Cabang',
    save: 'Simpan',
    reporttxt: 'Laporan',
    general: 'Umum',
    signOut: 'Keluar',
    registration: '',
    unit: 'Satuan',
    category: 'Kategori',
    product: 'Produk',
    export: 'Ekspor',
    exportKBank: 'Ekspor K-Bank',
    date: 'Tanggal',
    to: 'Sampai',
    status: 'Status',
    vatAmount: 'Pajak',
    netTotalNonVAT: 'Total (tanpa Pajak)',
    receiptNumber: 'Nomor Kwitansi',
    grandTotal: 'Total Keseluruhan',
    netAmountVATTotal: 'Sub-Total',
    netTotalIncVAT: 'Total (termasuk Pajak)',
    proofOfPayment: 'Bukti pembayaran',
    paymentType: 'Jenis Pembayaran',
    paymentType0: 'Tunai',
    paymentType1: 'Kartu kredit',
    paymentType2: 'Kupon',
    paymentType3: 'Quickpay',
    paymentType4: 'Promptpay',
    paymentType5: 'Alipay',
    paymentType6: 'Deposit',
    paymentType7: 'Pengiriman',
    paymentType8: 'Online',
    paymentType9: 'Line Pay',
    paymentType10: 'Pembayaran Kustom',
    paymentType12: 'KBank',
    paid: 'Nilai pembayaran',
    sentSuccessfully: 'Berhasil dikirim',
    pluCode: 'Barcode',
    netAmount: 'Total Bersih',
    discount: 'Diskon',
    timeOfOrder: 'Waktu pesanan',
    orderDate: 'Tanggal Pesanan',
    preparing: 'Menyiapkan',
    paymentDetail: 'Detail Pembayaran',
    orderNumber: 'Nomor Pesanan',
    delivered: 'Tenggat waktu',
    deliveredDate: 'Waktu tunggu',
    payment: 'Pembayaran',
    productName: 'Nama Produk',
    quantity: 'Jumlah',
    priceUnit: 'Harga/Satuan',
    baht: 'Baht',
    profit: 'Keuntungan',
    sales: 'Penjualan',
    billAmount: 'Total tagihan',
    total: 'Total',
    bill: 'Tagihan',
    discountAmount: 'Jumlah Diskon',
    averageBill: 'Rata-rata/tagihan',
    voidbillTotal: 'Total Tagihan Batal',
    salesByDaily: 'Penjualan Harian',
    salesByMonth: 'Penjualan Bulanan',
    bestSellers: 'Produk Terlaris',
    bestSellerstype: 'Kategori Terlaris',
    salesBydate: 'Penjualan berdasarkan tanggal',
    number: 'No.',
    categoryName: 'Nama Kategori',
    newOrder: 'Pesanan Terkirim',
    reject: 'Tolak',
    inProgressTime: 'Waktu Proses',
    rejectTime: 'Waktu Penolakan',
    cancelTime: 'Waktu Pembatalan',
    cause: 'Penyebab',
    preparingToShip: 'Menyiapkan',
    totalAmount: 'Total',
    order: 'Pesanan',
    deposit: 'Deposit',
    billSave: 'Simpan',
    ReceivingOrder: 'Buka meja/Terima pesanan',
    orderNo: 'No. Pesanan',
    remark: 'Catatan',
    receiptStatus: 'Status Kwitansi',
    back: 'Kembali',
    detail: 'Detail',
    countSales: 'Jumlah',
    onhandQty: 'Saldo',
    stdCost: 'Biaya',
    employees: 'Karyawan',
    employeesname: 'Nama Karyawan',
    salesTotal: 'Total Penjualan',
    totalBill: 'Jumlah semua tagihan',
    billActive: 'Jumlah tagihan aktif',
    billVoice: 'Jumlah tagihan batal',
    billDeposit: 'Jumlah tagihan deposit',
    discountItem: 'Total diskon item',
    billDiscountAmount: 'Total diskon tagihan',
    billDiscount: 'Jumlah tagihan diskon',
    payTotal: 'Total Pembayaran',
    deliveryProvider: 'Penyedia Pengiriman',
    deliveryDetail: 'Detail Pengiriman',
    customDetail: 'Detail Pembayaran Kustom',
    customPaymentName: 'Nama Pembayaran Kustom',
    firstInvoiceNO: 'No. tagihan pertama',
    lastInvoiceNO: 'No. tagihan terakhir',
    roundNo: 'No. Ronde',
    closeAt: 'Tutup Pada',
    closeBy: 'Ditutup Oleh',
    totalCashSales: 'Total Penjualan Tunai',
    initialChange: 'Uang Kembalian Awal',
    totalCashIn: 'Total kas masuk',
    totalCashOut: 'Total kas keluar',
    actualInDrawer: 'Aktual di laci',
    expectedInDrawer: 'Diharapkan di laci',
    difference: 'Selisih',
    voidBillDetail: 'Detail tagihan batal',
    cancelBy: 'Dibatalkan Oleh',
    cancelDate: 'Tanggal Batal',
    searchByEmployees: 'Cari berdasarkan karyawan',
    search: 'Cari',
    timeIn: 'Jam masuk',
    timeOut: 'Jam keluar',
    time: 'Waktu',
    hours: 'Jam',
    seconds: 'Detik',
    netTotal: 'Total',
    reason: 'Alasan',
    searchByProduct: 'Cari berdasarkan produk',
    sortBy: 'Urutkan',
    last: 'Terbaru',
    price: 'Harga produk',
    sortByNumMin: 'Harga terendah',
    sortByNumMax: 'Harga tertinggi',
    documentNo: 'No. Dokumen',
    transactionType: 'Jenis Transaksi',
    updatedBy: 'Diperbarui Oleh',
    transactionType1: 'Jual',
    transactionType2: 'Pengembalian',
    transactionType3: 'Stok masuk',
    transactionType4: 'Stok keluar',
    transactionType5: 'Penyesuaian stok masuk',
    transactionType6: 'Penyesuaian stok keluar',
    transactionType7: 'Tukar poin',
    transactionType8: 'Hapus stok masuk',
    transactionType9: 'Hapus stok keluar',
    transactionType10: 'Edit stok masuk',
    transactionType11: 'Edit stok keluar',
    billNo: 'No. Tagihan',
    docTotal: 'Total',
    customer: 'Pelanggan',
    username: 'Nama Pengguna',
    dateOfBill: 'Tanggal Tagihan',
    selectDate: 'Pilih Tanggal',
    dialogSelectCategory: 'Silakan pilih kategori untuk pencarian',
    dialogUpdateDocumentSuccess: 'Dokumen berhasil diperbarui',
    dialogfound: 'Informasi yang dimasukkan salah.',
    isVatIncluded: 'Apakah PPN Termasuk',
    vatIccludes: 'PPN',
    confirmStock: 'Konfirmasi stok',
    confirm: 'Konfirmasi',
    deleteDoc: 'Hapus Dokumen',
    confirmUpdateDocModal: 'Apakah Anda ingin memperbarui dokumen stok?',
    confirmSaveDoc: 'Konfirmasi simpan dokumen',
    confirmDeleteDoc: 'Konfirmasi hapus dokumen',
    confirmDeleteModal: 'Apakah Anda ingin menghapus dokumen stok?',
    dialogSaveDocumentSuccess: 'Dokumen berhasil disimpan',
    createStockIn: 'Buat Stok Masuk',
    confirmSaveDocModal: 'Apakah Anda ingin menyimpan dokumen stok?',
    selectShopPlease: 'Silakan pilih toko',
    selectProductPlease: 'Silakan pilih produk',
    duplicateProduct: 'Anda sudah memilih item ini.',
    productInvilid: 'Item yang Anda pilih tidak valid. Silakan hubungi administrator sistem.',
    confirmStockOut: 'Konfirmasi stok keluar',
    dialogSaveDocumentOutSuccess: 'Dokumen berhasil disimpan',
    confirmSaveDocStockOutModal: 'Apakah Anda ingin menyimpan dokumen stok keluar?',
    adjustDocType: 'Jenis Dokumen Penyesuaian',
    adjustDocType1: 'Tambah',
    adjustDocType2: 'Kurangi',
    beforeAdjust: 'Sebelum penyesuaian stok',
    afterAdjust: 'Setelah penyesuaian stok',
    adjust: 'Penyesuaian stok',
    createDoucument: 'Buat Dokumen',
    transferType: 'Jenis Transfer',
    transferType1: 'Transfer masuk',
    transferType2: 'Transfer keluar',
    new: 'Baru',
    finish: 'Selesai',
    refDocument: 'Referensi Dokumen',
    statusDoc: 'Status Dokumen',
    dialogSaveTransferDocumentSuccess: 'Dokumen transfer berhasil dibuat',
    destinationShop: 'Toko tujuan',
    destinationShopBranch: 'Cabang tujuan',
    sourceBranch: 'Cabang Asal',
    sourceShop: 'Toko Asal',
    sourceAddress: 'Alamat asal',
    destinationAddress: 'Alamat tujuan',
    saveTransfer: 'Simpan transfer stok',
    confirmSaveTransfer: 'Apakah Anda ingin menyimpan transfer stok?',
    savinserviceChargegDoc: 'Menyimpan dokumen',
    selectdestinationPlease: 'Silakan pilih cabang tujuan',
    validatedestinationproduct: "Cabang tujuan tidak memiliki produk ini",
    validateProduct: 'Silakan pilih produk',
    created_by: 'Oleh',
    receive: 'Terima',
    updateDoc: 'Perbarui dokumen',
    cancelDoc: 'Batalkan dokumen',
    confirmCancelDoc: 'Apakah Anda ingin membatalkan dokumen ini?',
    cancelingDoc: 'Membatalkan dokumen',
    updatingDoc: 'Memperbarui dokumen',
    updateDocFail: "Tidak dapat memperbarui dokumen",
    cancelDocSuccess: 'Dokumen dibatalkan',
    cancelDocFail: "Tidak dapat membatalkan dokumen",
    refDocumentTransfer: 'Ref. Dokumen',
    comfrimTransferIn: 'Konfirmasi transfer stok masuk',
    dilogcomfrimTransferIn: 'Apakah Anda ingin transfer stok masuk dokumen?',
    transferInDetail: 'Detail transfer stok',
    totalNet: 'Total bersih',
    confirmAdjust: 'Konfirmasi penyesuaian stok',
    createStockOut: 'Buat stok keluar',
    favorite: 'Favorit',
    isOnScreen: 'Tampil di Layar',
    negotiatePrice: 'Negosiasi Harga',
    productTypeP: 'Produk Umum',
    productTypeBOM: 'Bill of Material',
    productTypeSN: 'Produk Serial',
    productTypeSV: 'Layanan (tanpa stok)',
    productPLU: 'Ukuran kemasan lainnya',
    productBOM: 'Material',
    productSN: 'Serial Number',
    morePrice: 'Harga Lainnya',
    cost: 'Biaya',
    quantityPrice: 'Jumlah',
    exceedUc: 'Harga',
    changeImg: 'Ubah gambar',
    addProduct: 'Tambah Produk',
    selectImg: 'Pilih gambar',
    deleteImg: 'Hapus gambar',
    selectImgFromPC: 'Pilih gambar dari PC',
    confirmSaveImgDialog: 'Apakah Anda ingin menyimpan produk?',
    confirmSaveImg: 'Konfirmasi simpan produk.',
    addPrice: 'Tambah Harga',
    editPrice: 'Edit Harga',
    dialigDeleteProduct: 'Apakah Anda ingin menghapus produk?',
    confirmDeleteProduct: 'Konfirmasi hapus produk ini.',
    productType: 'Jenis Produk',
    countProduct: 'Jumlah produk',
    addUnit: 'Tambah Satuan',
    editUnit: 'Edit Satuan',
    active: 'Aktif',
    inactive: 'Tidak Aktif',
    confirmSaveUnitDialog: 'Apakah Anda ingin menyimpan satuan?',
    confirmSaveUnit: 'Konfirmasi simpan satuan ini.',
    dialigDeleteUnit: 'Apakah Anda ingin menghapus satuan?',
    confirmDeletUnit: 'Konfirmasi hapus satuan ini.',
    confirmSaveCategoryDialog: 'Apakah Anda ingin menyimpan kategori?',
    confirmSaveCategory: 'Konfirmasi simpan kategori ini.',
    dialigDeleteCategory: 'Apakah Anda ingin menghapus kategori?',
    confirmDeletCategory: 'Konfirmasi hapus kategori.',
    addCategory: 'Tambah Kategori',
    editCategory: 'Edit Kategori',
    bgColor: 'Warna latar belakang',
    selectbgColor: 'Pilih warna latar belakang',
    validateCategoryname: 'Silakan masukkan nama kategori.',
    sequence: 'Urutan',
    enterProduct: 'Silakan masukkan nama produk.',
    enterPrice: 'Silakan masukkan harga produk.',
    selectCategory: 'Silakan pilih kategori produk.',
    selectUnit: 'Silakan pilih satuan produk.',
    confirmSaveProduct: 'Apakah Anda ingin menyimpan produk ini?',
    confirmSaveProductPrice: 'Apakah Anda ingin menyimpan harga lainnya?',
    validatepackQty: 'Silakan masukkan Harga/Satuan.',
    validatepackUc: 'Silakan masukkan harga.',
    validatePRU: 'Data duplikat, Silakan masukkan lagi.',
    createProductSuccess: 'Produk berhasil dibuat',
    addSerial: 'Tambah Serial',
    add: 'Tambah',
    createSerial: 'Buat Serial Number',
    available: 'Siap dijual',
    soldOut: 'Habis',
    deleteSuccess: 'Berhasil dihapus',
    enterSerial: 'Silakan masukkan Serial Number',
    confirmSaveSerial: 'Apakah Anda ingin menyimpan Serial Number ini?',
    confirmDelete: 'Apakah Anda ingin menghapus Serial Number ini?',
    addProductPLU: 'Tambah ukuran kemasan',
    img: 'Gambar',
    SKURatio: 'Rasio',
    editProductPLU: 'Edit ukuran kemasan',
    enterSKURatio: 'Silakan masukkan Rasio',
    comfrimDeletePLU: 'Apakah Anda ingin menghapus ukuran kemasan ini?',
    useStepPrice: 'Gunakan harga bertingkat',
    addBOM: 'Tambah Material',
    confirmSaveBOM: 'Apakah Anda ingin menyimpan Material?',
    user: 'Pengguna',
    userDetail: 'Detail Pengguna',
    planDetail: 'Detail Paket',
    currentPlan: 'Paket Saat Ini',
    expireDate: 'Tanggal Kedaluwarsa',
    startDate: 'Tanggal Mulai',
    dialogSignOut: 'Apakah Anda ingin keluar?',
    confirmSignOut: 'Konfirmasi keluar',
    countMember: 'Semua anggota',
    addMenber: 'Tambah anggota',
    searchMember: 'Cari berdasarkan nama, email, dan telepon',
    dateOfMember: 'Tanggal anggota',
    recentVisit: 'Kunjungan terakhir',
    memberName: 'Nama anggota',
    email: 'Email',
    paymentTotal: 'Total pembayaran',
    point: 'Poin',
    pointtxt: 'Poin',
    postalCode: 'Kode pos',
    saveing: 'Menyimpan...',
    edit: 'Edit',
    editMember: 'Edit anggota',
    deleteing: 'Menghapus...',
    dialogDeleteMember: 'Apakah Anda ingin menghapus anggota?',
    confirmDeleteMember: 'Konfirmasi hapus',
    valtdateMember: 'Silakan isi informasi',
    createMemberSuccess: 'Anggota berhasil ditambahkan!',
    updateMemberSuccess: 'Anggota berhasil diedit!',
    deleteMemberSuccess: 'Anggota berhasil dihapus!',
    onhandQtyMin: 'Stok Min',
    onhandQtyMax: 'Stok Maks',
    onhandQtySort: 'Jumlah Stok',
    showProductAll: 'Semua Jenis Produk',
    updateAt: 'Terakhir diperbarui',
    sortName: 'Nama',
    stockUnit: 'Biaya/Satuan',
    deleteCategory: 'Hapus kategori',
    selectd: 'Pilih',
    searchProduct: 'Cari Produk',
    reset: 'Reset',
    selectdProduct: 'Pilih produk',
    information: 'Informasi',
    adjustStockList: 'Produk penyesuaian stok',
    adjustDetail: 'Tambah produk ke daftar penyesuaian stok dan pengaturan',
    transferoutList: 'Produk transfer stok',
    addProductTransfer: 'Tambah produk ke daftar transfer stok dan pengaturan',
    transferDetail: 'Produk ke daftar stok keluar dan pengaturan',
    transferinList: 'Produk ke daftar stok masuk dan pengaturan',
    stockOutList: 'Produk stok keluar',
    addstockOutList: 'Tambah produk ke daftar stok keluar dan pengaturan',
    stockinList: 'Produk stok masuk',
    addProductStockin: 'Tambah produk ke daftar stok masuk dan pengaturan',
    checkCount: 'Periksa stok',
    createAdjustStock: 'Buat penyesuaian stok',
    memberDetail: 'Informasi anggota',
    package: 'Detail paket',
    startPackate: 'Mulai Paket',
    endPackate: 'Akhir Paket',
    name: 'Nama',
    productImg: 'Gambar produk',
    fistname: 'Nama Depan',
    lastname: 'Nama Belakang',
    saveMember: 'Simpan informasi',
    confirmSaveMember: 'Apakah Anda ingin menyimpan anggota?',
    yesOrNo: 'ya atau tidak',
    totaValue: 'Total',
    deleteMember: 'Hapus anggota',
    frequently: 'Produk sering dibeli',
    recentPurchase: 'Pembelian terakhir',
    paymentDescription: 'Deskripsi pembayaran',
    validateInfomation: 'Silakan masukkan informasi',
    validateTel: 'Nomor telepon salah',
    validateOTP: 'OTP salah',
    validateEmail: 'Email salah',
    saveSuccess: 'Berhasil Disimpan',
    txtcustomer: 'Pelanggan',
    customerName: 'Nama pelanggan',
    customerCount: 'Jumlah pelanggan',
    addCustomer: 'Tambah pelanggan',
    permissionManage: 'Izin',
    mainMenu: 'Menu Utama',
    page: 'Halaman',
    show: 'Tampilkan',
    delete: 'Hapus',
    administratorTools: 'Alat Administrator',
    deviceName: 'Nama Perangkat',
    lastSyncProduct: 'Sinkronisasi Terakhir',
    version: 'Versi',
    posstatus: 'Status',
    posNumber: 'Nomor POS',
    titleSilomconnect: 'Jangan lewatkan penjualan dengan layanan dari',
    updateSilom: 'Perbarui penjualan harian melalui LINE gratis',
    addfriend: 'Tambah teman',
    enterToReciveService: 'Tekan untuk menerima kode layanan.',
    verifyCodeToUsed: 'Untuk mulai menggunakan sistem, Anda dapat menekan untuk menerima kode verifikasi identitas.',
    verifyfivemin: 'Kode verifikasi dapat digunakan dalam 5 menit.',
    yourVertify: 'Kode verifikasi Anda adalah',
    pressCode: 'Tekan terima kode',
    exCode: 'Kode kedaluwarsa dalam',
    sessionEx: 'Sesi login telah berakhir. Silakan login kembali.',
    refresh: 'Muat ulang',
    selectedFile: 'Pilih File',
    fileSize: 'Ukuran file tidak lebih dari 2 MB.',
    isBeingToUsed: 'Sedang digunakan',
    notInUse: 'Tidak digunakan',
    delete: 'Hapus',
    confirmUpdateInformation: 'Konfirmasi perbarui informasi',
    memberCount: 'Jumlah',
    orderMachine: 'Perangkat Pesanan',
    textMember: 'Anggota',
    manageShop: 'Manajemen informasi toko',
    lansetting: 'Pengaturan bahasa dan zona waktu toko',
    timezoneSetiing: 'Pengaturan zona waktu toko',
    deliveryProviderSetting: 'Penyedia pengiriman untuk toko',
    toolsSetting: 'Kelola mesin POS untuk toko',
    checkStockPLU: 'Saldo produk < 0',
    searching: 'Mencari',
    allProduct: 'Semua Produk',
    foundProductOnhand: 'Ditemukan produk dengan stok < 0',
    confirmAdjustBefor: 'Apakah Anda ingin penyesuaian otomatis oleh sistem?',
    requireAdjust: 'Ya',
    imrequireAdjust: 'Tidak',
    islimitItemTodoc: 'Anda dapat memilih hingga 200 item / 1 dokumen.',
    barcodePrint: 'Cetak Barcode',
    printEx: 'Cetak & Contoh',
    print: 'Cetak',
    downloadAndExport: 'Unduh dan cetak',
    selectFormat: 'Pilih format kertas',
    peperFormat: 'Format kertas',
    optional: 'Opsional',
    standardA427: 'A4 Standar: 27 item/halaman',
    standardA450: 'A4 Standar: 52 item/halaman',
    standardA460: 'A4 Standar: 60 item/halaman',
    standardA556: 'A4 Standar: 56 item/halaman (ukuran stiker: A5)',
    standardA550: 'Kertas A5: 52 item/halaman',
    standardA560: 'Kertas A5: 60 item/halaman',
    countBarcode: 'Jumlah barcode',
    barcode: 'Barcode',
    setFontsize: 'Pengaturan font',
    accessPermissionDes: 'Tetapkan akses untuk pengguna.',
    deleteUser: 'Konfirmasi hapus pengguna',
    confirmDeleteUser: 'Apakah Anda ingin menghapus pengguna?',
    passAtless: 'Kata sandi minimal 6 karakter.',
    inValidPass: 'Kata sandi salah',
    createBy: 'Dibuat Oleh',
    adjustAutoDes: "Jika Anda tidak ingin sistem memperbarui secara otomatis, total saldo produk mungkin salah.",
    addUser: 'Tambah pengguna',
    isMenu: 'Tampil di menu pelanggan',
    menuSmart: 'Atur menu produk',
    smartSettingTitle: 'Pengaturan Menu',
    smartSetting: 'Pengaturan menu untuk Silom CRM',
    confirmEnable: 'Apakah Anda ingin mengaktifkan menu?',
    confirmDisEnable: 'Apakah Anda ingin menonaktifkan menu?',
    confirmSelfOrderEnable: 'Apakah Anda ingin mengaktifkan menu self-order?',
    confirmSelfOrderDisable: 'Apakah Anda ingin menonaktifkan menu self-order?',
    enable: 'Aktifkan',
    disable: 'Nonaktifkan',
    usabilityStatus: 'Diaktifkan',
    manageSmartOnProduct: 'Anda dapat "tambah/edit" daftar produk yang ingin ditampilkan di menu pelanggan.',
    manageSmartOnCategory: 'Anda dapat "tambah/edit" daftar kategori yang ingin ditampilkan di menu pelanggan.',
    turnonSmart: 'dan aktifkan menu',
    manageShopDes: 'Anda dapat merujuk ke panduan pengguna di -',
    desSmartMenu: 'Atur menu produk untuk menampilkan E-menu di LINE agar pelanggan mudah mengakses dan memesan sendiri.',
    link: 'tautan',
    createTranferOut: 'Buat dokumen transfer keluar',
    roundingValue: 'Penyesuaian Pembulatan',
    limitItems: 'Dapat memilih produk maksimal 200 item',
    IncomeCategory: 'Pendapatan',
    ExpenseCategory: 'Pengeluaran',
    saveBy: 'Disimpan oleh',
    saveDate: 'Tanggal simpan',
    drawerCate: 'Kategori',
    openingHours: 'Jam buka',
    shopLocation: 'Lokasi toko',
    sunday: 'Minggu',
    monday: 'Senin',
    tuesday: 'Selasa',
    wednesday: 'Rabu',
    thursday: 'Kamis',
    friday: 'Jumat',
    saturday: 'Sabtu',
    lat: 'Lintang',
    lng: 'Bujur',
    shopCoverSetting: 'Pengaturan sampul toko',
    shopCoverSettingDes: 'Atur sampul toko untuk ditampilkan di layar pelanggan',
    locationSettingDes: 'Pengaturan lokasi',
    updatelocation: 'Perbarui lokasi',
    searchLocation: 'Cari Lokasi',
    imaginaryLine: 'Garis Imajiner',
    openingHoursDes: 'Atur jam buka toko',
    paymentDescriptionConfig: 'Pilih Metode Pembayaran',
    creditCard: 'Kartu Kredit',
    promptPay: 'Promptpay',
    coupon: 'Kupon',
    quickpay: 'Krungsri Quick Pay',
    alipay: 'Alipay',
    linepay: 'Rabbit LINE Pay',
    thaidotcom: 'Thai Dot Com Payment',
    mounth: 'bulan',
    dayMY: 'Tanggal',
    item: 'Item',
    byStockIn: 'Stok Masuk',
    stockOutOther: 'Lainnya',
    drawerSales: 'Penjualan',
    sumIncomeExpenses: 'Ringkasan pendapatan-pengeluaran',
    incomeOther: 'Pendapatan Lain',
    loss: 'Rugi',
    grossProfit: 'Laba Kotor',
    newUser: 'Pengguna baru',
    userType: 'Jenis Pengguna',
    password: 'Kata sandi',
    confirmPassword: 'Konfirmasi Kata sandi',
    ParticipatingProducts: 'Pilih produk',
    descriptionSilomOrder: 'Pilih produk untuk order.silompos.com',
    cashierManagement: 'Manajemen Kasir',
    cashierManageButton: 'Kelola',
    cashierUsernamePassword: 'Nama Pengguna dan Kata Sandi Kasir',
    cashierCRUDDescription: 'Untuk login order.silompos.com',
    password: 'Kata sandi',
    placeholderPassword: 'Masukkan kata sandi',
    resetPassword: 'Reset Kata Sandi',
    oldPassword: 'Kata Sandi Lama',
    oldPasswordPlaceholder: 'Kata sandi lama',
    newPassword: 'Kata Sandi Baru',
    purchaseDetail: 'Detail Pembelian',
    uploadImage: 'Unggah Gambar',
    keyword: 'kata kunci',
    firstname: 'Nama Depan',
    lastname: 'Nama Belakang',
    province: 'Provinsi',
    district: 'Kabupaten/Kota',
    subdistrict: 'Kecamatan',
    addressNumber: 'Alamat',
    setAsDefaultAddress: 'Atur sebagai alamat default',
    setAsTaxAddress: 'Atur sebagai alamat pajak',
    setAsShippingAddress: 'Atur sebagai alamat pengiriman',
    contact: 'Kontak',
    setAsDefault: 'Atur sebagai default',
    addressLists: 'Daftar alamat',
    default: 'Default',
    taxAddress: 'Faktur pajak',
    shippingAddress: 'Pengiriman',
    addAddress: 'Tambah',
    createdAt: 'Dibuat',
    updatedAt: 'Diperbarui',
    by: 'oleh',
    readyForSale: 'siap dijual',
    sold: 'terjual',
    delete: 'hapus',
    items: 'Item',
    itemDiscount: 'Diskon item',
    failedToSave: 'Gagal menyimpan!',
    dateOfBirth: 'Tanggal lahir',
    menu: 'Menu',
    dashboardMenu: 'Dasbor',
    transactionMenu: 'Transaksi',
    currentBillMenu: 'Tagihan Saat Ini',
    reportMenu: 'Laporan',
    orderDeviceMenu: 'Perangkat Pesanan',
    memberMenu: 'Anggota',
    inventoryMenu: 'Inventaris',
    productMenu: 'Produk',
    selfOrderMenu: 'Saluran Penjualan',
    settingMenu: 'Pengaturan',
    salesReportByDate: 'Penjualan berdasarkan Tanggal',
    salesReportByBill: 'Penjualan berdasarkan Detail Tagihan',
    salesQuantitySummaryByProductReport: 'Penjualan berdasarkan Produk',
    quantitySummaryByPLUReport: 'Penjualan berdasarkan Produk (PLU)',
    nonSellingProduct: 'Produk Tidak Terjual',
    salesSummaryByCashierReport: 'Penjualan berdasarkan Kasir',
    salesSummaryByCategoryReport: 'Penjualan berdasarkan Kategori',
    paymentReport: 'Pembayaran',
    salesTaxReport: 'Pajak Penjualan',
    drawerReport: 'Laci',
    voidBillReport: 'Tagihan Batal',
    timesheetReport: 'Absensi',
    stockInByListReport: 'Stok masuk berdasarkan Produk',
    stockOutByListReport: 'Stok keluar berdasarkan Produk',
    nonAdjustStockProductReport: 'Produk stok belum disesuaikan',
    exportProductReport: 'Ekspor produk',
    salesSummaryByOrderReport: 'Berdasarkan Perangkat Pesanan',
    salesSummaryProductByOrderReport: 'Berdasarkan Produk',
    voidBillByOrderReport: 'Tagihan batal',
    inventoryReport: 'Laporan Inventaris',
    inventoryReportByPLU: 'Laporan Inventaris berdasarkan PLU',
    inventoryReportBySerial: 'Laporan Inventaris berdasarkan Serial No.',
    stockMovement: 'Pergerakan Stok',
    stockInDocument: 'Dokumen Stok Masuk',
    stockOutDocument: 'Dokumen Stok Keluar',
    adjustStockDocument: 'Dokumen Penyesuaian Stok',
    selfOrder: 'Self Order',
    cashier: 'Kasir',
    permission: 'Izin',
    menuSetting: 'Pengaturan Menu',
    management: {
        txtManagement: 'Manajemen',
        user: 'Akun',
        shopBranch: 'Toko dan Cabang',
        productManagement: 'Produk',
        unitManagement: 'Satuan',
        categorytManagement: 'Kategori',
        inventory: 'Inventaris',
        stockIn: 'Stok Masuk',
        stockOut: 'Stok Keluar',
        adjustStock: 'Penyesuaian Stok',
        checkStock: 'Periksa stok',
        stockMovement: 'Pergerakan Stok',
        transferStock: 'Transfer Stok',
        reportByPLU: 'Laporan Inventaris berdasarkan PLU',
        reportBySKU: 'Laporan Inventaris',
        txtreportBySKU: 'Laporan Inventaris',
        txtreportByPLU: 'Laporan Inventaris berdasarkan PLU',
        stockInDoc: 'Dokumen Stok Masuk',
        stockOutDoc: 'Dokumen Stok Keluar',
        adjustStockDoc: 'Dokumen Penyesuaian Stok',
        transferStockDoc: 'Dokumen Transfer Stok',
        transferStockInDoc: 'Dokumen Transfer Stok Masuk',
        transferStockOutDoc: 'Dokumen Transfer Stok Keluar',
    },
    report: {
        dashboard: 'Dasbor',
        transaction: 'Transaksi',
        currentbill: 'Tagihan Saat Ini',
        daily: 'Berdasarkan Tanggal',
        txtdaily: 'Laporan penjualan berdasarkan Tanggal',
        dailyDes: 'Detail laporan penjualan berdasarkan tanggal',
        sellbyProduct: 'Berdasarkan Detail Tagihan',
        txtsellbyProduct: 'Laporan penjualan berdasarkan Detail Tagihan',
        sku: 'Berdasarkan Produk',
        txtsku: 'Laporan penjualan berdasarkan Produk',
        plu: 'Berdasarkan Produk (PLU)',
        textPlu: 'Laporan penjualan berdasarkan Produk (PLU)',
        paymentreport: 'Laporan Pembayaran',
        txtpaymentreport: 'Laporan Pembayaran',
        timesheet: 'Absensi',
        txtTimesheet: 'Laporan Absensi',
        unsell: 'Produk Tidak Terjual',
        txtUnsell: 'Produk Tidak Terjual',
        byCategory: 'Berdasarkan Kategori',
        txtbyCategory: 'Laporan penjualan berdasarkan Kategori',
        byCashier: 'Berdasarkan Kasir',
        txtbyCashier: 'Laporan penjualan berdasarkan Kasir',
        salesTax: 'Laporan Pajak Penjualan',
        txtSalesTax: 'Laporan Pajak Penjualan',
        voidbill: 'Tagihan Batal',
        txtvoidbill: 'Laporan tagihan batal',
        closedSale: 'Penjualan Ditutup',
        txtCloseSale: 'Laporan Laci',
        salesByOrder: 'Ringkasan penjualan',
        productByOrder: 'Berdasarkan Produk',
        unsalesByOrder: 'Tagihan Batal',
        txtDeliveryRoport: 'Laporan pembayaran pengiriman',
        txtCustomReport: 'Laporan pembayaran kustom',
        txtSalesByOrder: 'Penjualan produk berdasarkan Perangkat Pesanan',
        txtDailyOrder: 'Laporan penjualan berdasarkan Perangkat Pesanan',
        txtViodOrder: 'Tagihan batal berdasarkan Perangkat Pesanan',
        nonadjust: 'Produk stok belum disesuaikan',
        txtnonadjust: 'Laporan produk stok belum disesuaikan',
        stockInReport: 'Laporan stok masuk berdasarkan Produk',
        stockOutReport: 'Laporan stok keluar berdasarkan Produk',
        stockIn: 'Stok masuk berdasarkan Produk',
        stockOut: 'Stok keluar berdasarkan Produk',
        exportProduct: 'Ekspor Produk',
        txtExportProduct: 'Laporan ekspor produk',
        cashDrawer: 'Laci',
        txtCashDrawerr: 'Laporan manajemen kas',
        cashRevenue: 'Pendapatan Kas',
    },
    drawer: {
        cashDrawer: 'Laci',
        txtCashDrawerr: 'Laporan manajemen kas',
        cashRevenue: 'Ringkasan pendapatan-pengeluaran',
        txtcashRevenue: 'Laporan ringkasan pendapatan-pengeluaran',
    },
    member: {
        txtmember: 'Anggota',
        register: 'Pendaftaran toko (LINE OA)',
        loyaltyPoint: 'Poin Loyalitas',
        storeCredit: 'Kredit Toko',
        deal: 'Promo',
        giftVoucher: 'Voucher Hadiah',
        referral: 'Undang',
        crm: 'Silom CRM',
    },
    unableStockDescription: 'Tidak dapat mengedit produk karena pembaruan stok setelah pembuatan dokumen.',
    noItem: 'Tidak ada item',
    enterProductName: 'Masukkan nama produk',
    ByCategory: 'Berdasarkan Kategori',
    ByCategoryDetail: 'Detail Berdasarkan Kategori',
    maximum: 'Maksimum',
    selectZone: 'Pilih Zona',
    minimum: 'Minimum',
    unlimited: 'Tidak Terbatas',
    startTime: 'Waktu Mulai',
    endTime: 'Waktu Selesai',

    "errorMessages": {
        "qrExpired": "QR Code Kedaluwarsa",
        "qrNotFound": "QR Code Tidak Ditemukan",
        "paymentSuccess": "Pembayaran Berhasil",
        "invalidQrType": "Jenis QR Code Tidak Valid",
        "tableMoved": "Meja Dipindahkan",
        "receiptVoided": "Kwitansi Telah Dibatalkan"
    },
    "errorDescriptions": {
        "qrExpired": "QR Code yang Anda gunakan telah kedaluwarsa.<br>Silakan hubungi staf kami untuk bantuan.",
        "qrNotFound": "Informasi QR Code untuk memesan makanan tidak ditemukan.<br>Silakan hubungi staf kami.",
        "paymentSuccess": "Terima kasih telah menggunakan layanan kami!",
        "invalidQrType": "Silakan hubungi staf kami untuk mendapatkan QR Code dinamis.",
        "tableMoved": "Silakan hubungi staf kami untuk mendapatkan QR Code baru.",
        "receiptVoided": "Terima kasih telah menggunakan layanan kami.<br>Silakan hubungi staf jika Anda memerlukan bantuan."
    },
    waitForServe: 'Menunggu Penyajian',
    DineInPaymentDetails: 'Pembayaran',
    silomPayProDesp: 'Pembayaran Aman oleh Silom Pay Easy',
    billDetail: 'Detail Tagihan',
    minute: 'menit',
    paymentTImeExpired: 'Waktu Habis',
    openApp: 'Buka Aplikasi',
    callPayStaffSuccess: 'Staf telah dipanggil<br>Silakan tunggu bantuan untuk menyelesaikan pembayaran',
    account: 'Akun',
    refNumber: 'No. Ref',
    QRCodeBBL: 'QR Code Kartu Kredit',
    trackOrderStatus: 'Lacak Status Pesanan',
    all: 'Semua',
    noOrderThisStatus: 'Tidak ada pesanan dalam status ini',
    orderCompleteThanks: 'Terima kasih telah menggunakan layanan kami!',
    OnPreparingYourOrder: 'Menyiapkan pesanan Anda...',
    goToTracking: 'Ke Halaman Pelacakan',
    "dine-in": 'Makan di Tempat',
    typeOfOrder: 'Jenis Pesanan',
    queue: 'Antrean',
    cooking: 'Memasak',
    orderedAt: 'Dipesan pada',
    orderTimeStatus: 'Waktu Pesanan',
    acceptTimeStatus: 'Waktu Terima',
    estTimeStatus: 'Waktu Est.',
    newOrderDelivery: 'Pesanan Baru',
    acceptOrderDelivery: 'Terima Pesanan',
    readyToServeDelivery: 'Siap Disajikan',
    orderCompleted: 'Pesanan Selesai',
    orderCanceled: 'Pesanan Dibatalkan',
    readyToShip: 'Siap Dikirim',
    scanForPayment: 'Pindai untuk Pembayaran',
    orderType: 'Jenis Pesanan',
    welcomeBack: "Selamat Datang Kembali 👋",
    welcomeBackDespt: "Masuk untuk melanjutkan memesan makanan",
    orLoginWith: "Atau Masuk dengan",
    dontHaveAccount: 'Belum punya akun?',
    register: 'Daftar',
    fullName: "Nama Lengkap",
    fullNameDespt: 'Nama lengkap Anda',
    emailDespt: 'Email Anda',
    createPassword: 'Buat Kata Sandi',
    alreadyHaveAccount: 'Sudah punya akun',
    verifyEmail: 'Verifikasi Email',
    enterOTPSentTo: 'Masukkan OTP yang dikirim ke',
    enterSixOTP: 'Masukkan OTP 6 digit',
    verifyOTP: 'Verifikasi OTP',
    weWillSentOTPEmail: 'Kami akan mengirim OTP ke email Anda',
    enterYourEmail: 'Masukkan email Anda',
    confirmNewPassword: 'Konfirmasi Kata Sandi Baru',
    sendOTP: 'Kirim OTP',
    addPhoneNumber: 'Tambah Nomor Telepon',
    addPhoneForRegister: 'Tambah Nomor Telepon untuk Pendaftaran',
    enterPhone: 'Masukkan Nomor Telepon',
    phoneUsed: 'Nomor telepon sudah digunakan',
    emailUsed: 'Email sudah digunakan',
    enterPassword: 'Masukkan Kata Sandi',
    registerEmail: 'Email Terdaftar',
    otpInvalid6: "Silakan masukkan OTP 6 digit yang valid.",
    emailVerified: "Email berhasil diverifikasi!",
    emailOrPasswordInvalid: 'Email atau kata sandi tidak valid',
    pleaseEnterEmail: 'Silakan masukkan email Anda',
    otpSentToEmail: "OTP dikirim ke email Anda",
    passwordNotMatch: "Kata sandi tidak cocok",
    resetPasswordCompleted: 'Kata sandi berhasil direset!',
    failResetPassword: 'Gagal mereset kata sandi',
    completePhoneFail: 'Pendaftaran telepon gagal',
    plaseEnterValidEmail: 'Silakan masukkan alamat email yang valid',
    invalidPhoneNumber: 'Telepon harus dimulai dengan 06, 08, atau 09 dan berisi 10 digit',
    example: 'Contoh',
    passwordSet: "Lebih dari 6 karakter dan harus menyertakan angka",
    SelectTableToAdd: 'Meja',
    availableTable: 'Tersedia',
    unAvailableTable: 'Tidak Tersedia',
    SelectTableToAddDesp: 'Pilih meja untuk makan di tempat<br>Catatan: Jika Anda ingin pindah meja, silakan hubungi staf',
    updatedStaus: 'Status Diperbarui',
    otpExpired: 'OTP Kedaluwarsa',
    and: "dan",
    emailOTP: "Email OTP",
    emailOTPDesp: "Masukkan OTP yang diterima via email",
    phoneOTP: "Telepon OTP",
    phoneOTPDesp: "Masukkan OTP yang diterima via SMS",
    checkSpamBox: '* Jika Anda belum menerima email, silakan periksa folder Spam atau Junk Anda. Terkadang butuh beberapa menit untuk tiba.',
    DineInPaymentPending: 'Pembayaran Tertunda',
    visitProceedPayment: 'Ke Pembayaran',
    proceedPayment: "Lanjutkan Pembayaran",
    proceedPaymentDesp: "Tagihan ini sedang diproses untuk pembayaran.<br>Jika Anda ingin memesan lebih banyak item,<br>silakan batalkan pembayaran yang sedang berlangsung terlebih dahulu",
    queueIndex: 'Antrean',
    otpSentToPhone: 'OTP telah dikirim via SMS.',
    failToSendOTP: 'Gagal mengirim OTP',
    somethingWentWrong: 'Terjadi kesalahan',
    tableHasNoOrder: 'Meja tidak memiliki pesanan',
    kbankProceedPaymentDesp: 'Tagihan ini sedang diproses untuk pembayaran.<br>Jika Anda ingin menambah item atau mengubah metode pembayaran,<br>silakan batalkan pembayaran yang sedang berlangsung terlebih dahulu'
,
  openHours: 'Buka',
}

export default messages
